<div *ngIf="resultsReady" id="id-mapper-results">
  <h2 class="id-heading">
    Mapping tool results for {{identifierMapperService.mapperType.displayName}} identifiers
  </h2>

  <div class="id-results-main">
  <button class="id-reset btn btn-primary"
          (click)="backToInput()">
    &larr; Go back
  </button>

  <div *ngIf="hasMatches()">
    <div class="found-message">
      Found {{allMatchesCount()}} {{organismCommonName}} {{geneOrGenes()}}.
    </div>
    <div class="send-genes">
      Use the {{geneOrGenes()}} as a gene list in the Advanced Search:
      <span *ngIf="showSubSetSelector()">
        <select class="subset-selector" [(ngModel)]="subsetForQueryBuilder">
          <option [ngValue]="'all'">All matches</option>
          <option *ngIf="hasOneToOneMatches()" [ngValue]="'one-to-one'">One to one matches</option>
          <option *ngIf="hasOneToManyMatches()" [ngValue]="'one-to-many'">One to many matches</option>
          <option *ngIf="hasManyToOneMatches()" [ngValue]="'many-to-one'">Many to one matches</option>
          <option *ngIf="hasManyToManyMatches()" [ngValue]="'many-to-many'">Many to many matches</option>
        </select>
      </span>
      <button class="btn btn-primary" (click)="sendToQueryBuilder()">Use {{geneOrGenes()}}</button>
    </div>
  </div>

  <div class="not-found-section" *ngIf="notFound().length != 0 && hasMatches()">
    <div *ngIf="showingAllNotFound()">
      <div class="not-found-heading">
        These {{identifierMapperService.mapperType.displayName}} identifiers could not be found:
      </div>
      <div class="not-found-ids">
        <span *ngFor="let id of notFound()">{{id}} </span>
      </div>
    </div>
    <div *ngIf="!showingAllNotFound()">
      <div class="not-found-heading">
        {{notFound().length}} {{identifierMapperService.mapperType.displayName}} identifiers could not be found, showing first {{INITIAL_NOT_FOUND}}:
      </div>
      <div class="not-found-ids">
        <span *ngFor="let id of displayNotFoundList()">{{id}} </span>
      </div>
      <div class="show-all-link">
        <a (click)="revealAllNotFound()">Show all identifiers ...</a>
      </div>
    </div>
  </div>

  <div class="not-found-section" *ngIf="notFound().length != 0 && !hasMatches()">
    <div class="not-found-heading">
      No matching {{organismCommonName}} genes were found for {{identifierMapperService.mapperType.displayName}} identifiers.
    </div>
  </div>

  <div class="one-one-section" *ngIf="hasOneToOneMatches()">
    <div class="one-one-heading">
      <span *ngIf="oneToOneMatchesCount() == 1">One identifier</span>
      <span *ngIf="oneToOneMatchesCount() != 1">{{oneToOneMatchesCount()}} identifiers</span>
      matched a single gene (one-to-one matches):
    </div>
    <div *ngIf="!showAllOneToOne()" class="show-all-link">
      <a (click)="revealAllOneToOne()">Show matches ...</a>
    </div>
    <div *ngIf="showAllOneToOne() && oneToOneMatchesCount() != 1" class="hide-all-link">
      <a (click)="hideAllOneToOne()">Hide matches</a>
    </div>
    <table *ngIf="showAllOneToOne()">
      <thead>
        <th>Identifier</th>
        <th>{{organismCommonName}} gene</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of oneToOneMatches() | keyvalue">
          <td>{{item.key}}</td>
          <td>
            <app-gene-link [long]="true" [gene]="item.value"></app-gene-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="one-to-many-section" *ngIf="hasOneToManyMatches()">
    <div class="multi-heading">
      <span *ngIf="oneToManyMatchesCount() == 1">One identifier</span>
      <span *ngIf="oneToManyMatchesCount() != 1">{{oneToManyMatchesCount()}} identifiers</span>

      in your list mapped to multiple genes (paralogs) in {{organismCommonName}}.
      All paralogs were included.
    </div>
    <div *ngIf="!showAllOneToMany()" class="show-all-link">
      <a (click)="revealAllOneToMany()">Show matches ...</a>
    </div>
    <div *ngIf="showAllOneToMany() && oneToManyMatchesCount() != 1" class="hide-all-link">
      <a (click)="hideAllOneToMany()">Hide matches</a>
    </div>
    <table *ngIf="showAllOneToMany()">
      <thead>
        <th>Identifier</th>
        <th>{{organismCommonName}} genes</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of oneToManyMatches() | keyvalue">
          <td>{{item.key}}</td>
          <td>
            <div *ngFor="let gene of item.value">
              <app-gene-link [long]="true" [gene]="gene"></app-gene-link>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="many-to-one-section" *ngIf="hasManyToOneMatches()">
    <div class="multi-heading">
      Many to one matches - paralogs from
      {{identifierMapperService.mapperType.displayName}} that match a {{organismCommonName}} gene:
    </div>
    <div *ngIf="!showAllManyToOne()" class="show-all-link">
      <a (click)="revealAllManyToOne()">Show matches ...</a>
    </div>
    <div *ngIf="showAllManyToOne() && manyToOneMatchesCount() != 1" class="hide-all-link">
      <a (click)="hideAllManyToOne()">Hide matches</a>
    </div>
    <table *ngIf="showAllManyToOne()">
      <thead>
        <th>Identifiers</th>
        <th>{{organismCommonName}} gene</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of manyToOneMatches() | keyvalue">
          <td>
            <div *ngFor="let queryId of item.value">
              {{queryId}}
            </div>
          </td>
          <td>
            <app-gene-link *ngIf="geneSummaryMap" [long]="true" [gene]="geneSummaryMap[item.key]"></app-gene-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="many-to-many-section" *ngIf="hasManyToManyMatches()">
    <div class="multi-heading">
      Many to many matches - {{identifierMapperService.mapperType.displayName}} paralogs
      that match {{organismCommonName}} paralogs:
    </div>
    <div *ngIf="!showAllManyToMany()" class="show-all-link">
      <a (click)="revealAllManyToMany()">Show matches ...</a>
    </div>
    <div *ngIf="showAllManyToMany() && manyToManyMatchesCount() != 1" class="hide-all-link">
      <a (click)="hideAllManyToMany()">Hide matches</a>
    </div>
    <table *ngIf="showAllManyToMany()">
      <thead>
        <th>Identifiers</th>
        <th>{{organismCommonName}} genes</th>
      </thead>
      <tbody>
        <tr *ngFor="let group of manyToManyMatches()">
          <td>
            <div *ngFor="let queryId of group[0]">
              {{queryId}}
            </div>
          </td>
          <td>
            <div *ngFor="let geneSummary of group[1]">
              <app-gene-link [long]="true" [gene]="geneSummary"></app-gene-link>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
</div>
